import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  retailerList: [],
  totalRecords: 0,
  loading: false,
};

const retailerSlice = createSlice({
  name: "retailer",
  initialState,
  reducers: {
    setRetailerList: (state, action) => {
      state.retailerList = action.payload.retailerList;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setRetailerList, setLoading } = retailerSlice.actions;
export default retailerSlice.reducer;
